module.exports = __webpack_public_path__ + "img/androidTip.62313956.webp";